import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import Page from 'components/Page';
import globalMessages from 'translations/messages';
import { AI_PROMPT_SETTINGS } from 'shared/constants/settings';
import SettingsList from 'components/Settings/SettingsList';
import SettingsDrawer from 'components/Settings/SettingsDrawer';

const AiPromptSettings = () => {
  const [edit, setEdit] = useState(false);

  return (
    <Page>
      <Page.Header
        title="AI Settings"
        extra={(
          <Button type="primary" onClick={() => setEdit(true)} icon={<EditOutlined />}>
            <FormattedMessage {...globalMessages.edit} />
          </Button>
        )}
      />
      <Page.Content>
        <SettingsList settings={AI_PROMPT_SETTINGS} relationId={null} refresh={!edit} />
        <SettingsDrawer settings={AI_PROMPT_SETTINGS} relationId={null} open={edit} onDone={() => setEdit(false)} onCancel={() => setEdit(false)} />
      </Page.Content>
    </Page>
  );
};

export default AiPromptSettings;
